import { AUTHORIZED, UNAUTHORIZED } from '../actions/types';

const initialState = {
  // token: localStorage.getItem('token'),
  token: null,
  isAuthenticated: null,
  loaded: false,
};

const auth = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AUTHORIZED:
      localStorage.setItem('token', payload.token);
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loaded: true,
      };
    case UNAUTHORIZED:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loaded: false,
      };

    default:
      return state;
  }
};

export default auth;
